module.exports = __webpack_public_path__ + "media/images/flags/tz-0ae3a1616fd93697411dcbb4c287ff9d.svg";